import { useConfirmationModalContext } from "features/modals/WorkspaceConfirmationModalV2"
import { CommentImageThumbnail } from "./CommentImageThumbnail"
import { CommentImagesModal } from "./CommentImagesModal"
import { useCommentImageUrls } from "./useCommentImageUrls"

export const CommentImages = ({ imageKeys }: { imageKeys: string[] }) => {
    const items = useCommentImageUrls(imageKeys)
    const { confirm } = useConfirmationModalContext()

    const urls = items.map((item) => item.url).filter(Boolean)

    const open = (startIndex: number) =>
        confirm({
            RenderComponent: ({ cancel }) => (
                <CommentImagesModal urls={urls} startIndex={startIndex} close={cancel} />
            ),
        })

    return (
        <div className="flex flex-wrap items-center gap-1 px-2 py-2">
            {items
                .filter((item) => !!item.url)
                .map((item, index) => (
                    <CommentImageThumbnail
                        key={item.id}
                        url={item.url}
                        onClick={() => open(index)}
                    />
                ))}
        </div>
    )
}
